export default {
  PLANNING_SELECT: 'PLANNING_SELECT',
  PLANNING_DEFAULT: 'PLANNING_DEFAULT',
  PLANNING_ACTION: 'PLANNING_ACTION',
  PLANNING_ACTIVE: 'PLANNING_ACTIVE',
  PLANNING_SORT: 'PLANNING_SORT',

  PLANNING_PENDING: 'PLANNING_PENDING',
  PLANNING_COMPLETE: 'PLANNING_COMPLETE',
  PLANNING_ERROR: 'PLANNING_ERROR',

  // MOAHR NAMESPACING PLEASE
  CONTAINER_PENDING: 'CONTAINER_PENDING',
  CONTAINER_COMPLETE: 'CONTAINER_COMPLETE',
  CONTAINER_ERROR: 'CONTAINER_ERROR',
}